import { Component } from '@angular/core';

@Component({
    selector: 'lokos-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrl: './page-not-found.component.scss',
    standalone: false,
})
export class PageNotFoundComponent {}
